import {FC, HTMLAttributes} from 'react'

export const DotIcon: FC<{size?: number} & HTMLAttributes<SVGSVGElement>> = ({size = 20, ...rest}) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...rest}>
        <rect x="4.66675" y="4.66663" width="6.66667" height="6.66667" rx="3.33333" fill="currentColor" />
    </svg>
)
